import { clientsCollection } from '@/firebase';
import moment from 'moment';

export default class ProjectsService {
  static async fetchCompanyClients(companyId) {
    const projects = [];
    const snapshot = await clientsCollection
      .where('company_id', '==', companyId)
      .get();

    snapshot.forEach((doc) => {
      const client = doc.data();
      const phones = [];

      if (client.main_phone) {
        phones.push(client.main_phone);
      }

      if (client.mobile_phone) {
        phones.push(client.mobile_phone);
      }

      projects.push({
        uid: doc.id,
        name: `${client.first_name} ${client.last_name}`,
        cpf: client.cpf,
        email: client.email,
        is_active: client.is_active,
        user_id: client.user_id,
        phones,
      });
    });

    return projects;
  }

  static async fetchClientProfile(clientId) {
    const client = await clientsCollection.doc(clientId).get();

    if (client) {
      return {
        uid: client.id,
        ...client.data(),
      };
    }

    return null;
  }

  static async createClient(data) {
    const seconds = moment().unix();
    const doc = clientsCollection.doc();

    doc.set({
      ...data,
      created_at: { seconds },
      updated_at: { seconds },
      is_active: true,
    });

    return doc.id;
  }

  static async updateClient(clientId, data) {
    const seconds = moment().unix();

    return clientsCollection
      .doc(clientId)
      .update({ ...data, updated_at: { seconds } });
  }

  static async deleteClient(clientId) {
    return clientsCollection.doc(clientId).delete();
  }

  static async assignClientToBroker(clientId, brokerId) {
    return { clientId, brokerId };
  }
}
